<div kalDialogHeader>

    <div class="kal-dialog__title">Dupliquer l'article sur Mon Espace CSE</div>

    <kal-icon (click)="close()">close</kal-icon>

</div>

<div kalDialogContent [formGroup]="form" [kalLoading]="loading">

    <ng-container *ngIf="applicationPublication.IdContent && applicationPublication.IsPublie">

        <p class="big gup-U-margin-bottom--small">Article Dupliqué</p>

        <p class="small gup-U-margin-bottom--normal gup-U-color--green" [ngSwitch]="applicationPublication?.Statut">
            <ng-container *ngSwitchCase="'DRAFT'">En cours de publication sur l'application</ng-container>
            <ng-container *ngSwitchCase="'SCHEDULED'">L'article sera publié sur l'application
                le {{ applicationPublication.DateDebut | date : 'dd/MM/yyyy' }}</ng-container>
            <ng-container *ngSwitchCase="'PUBLISHED'">Article publié sur l'application depuis
                le {{ applicationPublication.DateDebut | date : 'dd/MM/yyyy' }}</ng-container>
        </p>

    </ng-container>

    <!-- TITRE -->
    <kal-form-field>

        <kal-input id="web_administration_editorial_publishing_mon_espace_cse_title"
                   formControlName="title"
                   label="Titre de l'article"
                   (focusin)="hideTruncatedTitleWarning()"
                   required>
        </kal-input>
        <p class="small gup-O-msg -error" *ngIf="showTruncatedTitleWarning">Le titre a été coupé. Le titre de l'article
            sur l'application ne peut dépasser {{titleMaxLength}} caractères.</p>

    </kal-form-field>


    <!-- CONTENU -->
    <kal-form-field>

        <kal-textarea id="web_administration_editorial_publishing_mon_espace_cse_content"
                      formControlName="content"
                      label="Contenu"
                      required>
        </kal-textarea>

    </kal-form-field>

    <!-- ILLUSTRATION -->

    <div *ngIf="!pictureUrl; else pictureTemplate" class="gup-U-margin-bottom--mini">

        <a id="web_administration_editorial_publishing_mon_espace_cse_add_picture"
           (click)="openImagesBankDialog()"
           class="gup-C-moreInfos gup-O-link">
            <kal-icon>add</kal-icon>
            <span>Ajouter une image perso</span>
        </a>

        <p class="gup-O-msg -error" *ngIf="form.get('picture')?.errors">
            L'image est obligatoire pour une actualité
        </p>

    </div>

    <ng-template #pictureTemplate>

        <div class="gup-U-margin-bottom--mini">

            <figure (click)="openImagesBankDialog()" class="gup-U-margin-bottom--mini">

                <img id="web_administration_editorial_publishing_mon_espace_cse_picture"
                     [src]="pictureUrl"
                     alt="Illustration"
                     class="illustration"
                     (error)="invalidPicture = true">
            </figure>

            <p class="gup-O-msg -error" *ngIf="invalidPicture">
                L'image est invalide
            </p>

            <a id="web_administration_editorial_publishing_mon_espace_cse_delete_picture"
               appConfirmTitle="Suppression de l'illustration"
               appConfirmBody="Souhaitez-vous supprimer l'illustration ?"
               appConfirmSubmit="Supprimer"
               (appConfirm)="deletePicture()"
               class="gup-O-link -secondary">
                Supprimer
            </a>

        </div>

    </ng-template>


    <!-- DOCUMENTS -->
    <div class="gup-U-margin-bottom--mini">

        <label *ngIf="documentsList.length > 0">
            Documents
        </label>

        <!-- Liste des documents -->
        <ul>

            <li *ngFor="let document of documentsList" class="gup-U-margin-bottom--mini gup-U-padding-left--mini">
                <a target="_blank"
                   [href]="document.Url">
                    <kal-icon>attach_file</kal-icon>
                    {{ document.Filename }}
                </a>
                <a class="gup-O-link -secondary" (click)="unlinkDocument(document)">
                    Détacher de la publication
                </a>
            </li>

        </ul>

        <!-- Ajout document -->

        <a id="web_administration_editorial_article_edit_add_document"
           (click)="openDocumentsBankDialog()"
           class="gup-C-moreInfos gup-O-link">
            <kal-icon>add</kal-icon>
            <span>Ajouter un document</span>
        </a>

        <p class="small gup-U-color--400">
            La taille ne peut pas excéder {{maxFileSize}} ko.
        </p>


    </div>

    <!-- MOTS CLES -->
    <ng-template #displayAddTag>

        <div (click)="toggleDisplayTagInput()"
             id="web_administration_editorial_publishing_mon_espace_cse_toggle_display_tag_input"
             class="gup-U-margin-bottom--small">

            <a id="web_administration_editorial_publishing_mon_espace_cse_add_tag"
               class="gup-C-moreInfos gup-O-link">
                <kal-icon>add</kal-icon>
                <span>Ajouter un mot-clé</span>
            </a>

        </div>

    </ng-template>

    <div *ngIf="displayTagInput else displayAddTag" class="gup-U-margin-bottom--normal">

        <kal-form-field>

            <div class="tag-selection">
                <kal-input [placeholder]="tagsList.length >= 2 ? 'Vous ne pouvez pas ajouter plus de deux tags' : null"
                           (kalAutocompleteSelected)="pickTag($event.value)"
                           [formControl]="addTagControl"
                           [kalAutocomplete]="tagsListDatasource"
                           [kalClearOnPick]="true"
                           icon="search"
                           id="web_administration_editorial_publishing_mon_espace_cse_edit_tag"
                           label="Mots-clés ajoutés à l'article">
                </kal-input>
                <a id="web_administration_editorial_publishing_mon_espace_cse_add_tag_submit"
                   (click)="pickTag(addTagControl.value)"
                   class="gup-C-moreInfos gup-O-link add-tag"
                    *ngIf="tagsList.length < 2">
                    <kal-icon>add</kal-icon>
                    <span>Ajouter</span>
                </a>
            </div>


        </kal-form-field>

        <div *ngFor="let tag; index as i of tagsList" class="gup-O-badge">
            {{ tag }}
            <kal-icon (click)="deleteTag(i)">clear</kal-icon>
        </div>

    </div>


    <!-- PÉRIODE DE PUBLICATION-->
    <div *ngIf="!isFormDateDisplayed; else publicationDatesTemplate"
         (click)="togglePublicationDates()"
         class="gup-U-margin-bottom--small">

        <a id="web_administration_editorial_publishing_mon_espace_cse_add_publication_period"
           class="gup-C-moreInfos gup-O-link">
            <kal-icon>add</kal-icon>
            <span>Ajouter une période de publication</span>
        </a>

        <p class="small gup-U-color--400">
            L'article sera publié sur la période saisie à condition qu'il soit au statut validé.
        </p>

    </div>

    <ng-template #publicationDatesTemplate>

        <div class="gup-U-margin-bottom--normal">

            <app-date-range controlLabel="Période de publication"
                            displayDateEnd="true"
                            formControlName="publicationDates">
            </app-date-range>

            <a class="gup-O-link -secondary"
               (click)="togglePublicationDates()">
                Supprimer
            </a>

        </div>

    </ng-template>

    <p class="big gup-U-margin-bottom--normal">Préférences de diffusion</p>

    <!-- PROFIL DE PUBLICATION -->
    <kal-form-field class="gup-C-formFieldSize--select">

        <kal-select id="web_administration_editorial_publishing_mon_espace_cse_category"
                    formControlName="authorId"
                    label="Profil de publication">

            <kal-option [value]="null">
                Aucune
            </kal-option>

            <kal-option *ngFor="let profil of profilsList"
                        [value]="profil.IdProfile">
                {{ profil.NomProfile }}
            </kal-option>

        </kal-select>

    </kal-form-field>

    <!-- afficher à la une -->
    <kal-form-field class="without-label">

        <kal-checkbox id="web_administration_editorial_publishing_mon_espace_cse_is_top_article"
                      formControlName="isTopArticle"
                      kalTheme="switch"
                      label="Afficher à la Une">
        </kal-checkbox>

        <p class="small gup-U-color--400">
            L'article se retrouvera en tête de liste.
        </p>

    </kal-form-field>

    <!-- ENVOYER UNE NOTIFICATION -->
    <kal-form-field class="without-label">

        <kal-checkbox formControlName="sendNotification"
                      id="web_administration_editorial_publishing_mon_espace_cse_send_notification"
                      kalTheme="switch"
                      label="Envoyer une notification">
        </kal-checkbox>

        <p class="small gup-U-color--400">
            Les utilisateurs de l'application mobile recevront une notification pour les prévenir de la
            publication de l'article.
        </p>

    </kal-form-field>

    <!-- NOTIFICATION -->
    <div *ngIf="form.get('sendNotification').value"
         class="notification-informations">

        <!-- TITRE NOTIFICATION -->
        <kal-form-field>

            <kal-input id="web_administration_editorial_publishing_mon_espace_cse_send_notification_title"
                       formControlName="notificationTitle"
                       label="Titre de la notification">
            </kal-input>

        </kal-form-field>

        <!-- CONTENU NOTIFICATION -->
        <kal-form-field>

            <kal-textarea id="web_administration_editorial_publishing_mon_espace_cse_send_notification_content"
                          formControlName="notificationContent"
                          label="Contenu de la notification">
            </kal-textarea>

        </kal-form-field>

    </div>


</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">
            <kal-button id="rgpd_dialog_submit"
                        [disabled]="form.invalid || invalidPicture"
                        kalTheme="primary"
                        (click)="submit()">
                {{ submitButtonText }}
            </kal-button>
        </div>
        <div class="gup-O-list__item">
            <kal-button id="publishing_option_dialog_cancel"
                        kalTheme="secondary"
                        (click)="close()">
                Annuler
            </kal-button>
        </div>

    </div>

</div>
